import { IState } from '../../store';
import { IFlatTourBookingSchedule } from '../../types/flatTourBooking';

export function getFlatTourSchedule(state: IState): IFlatTourBookingSchedule | null {
  return state.flatTourBooking.schedule;
}
